import React, { Fragment, useContext, useEffect, useState } from "react";
import { ListingCard } from "shared-components/ViewFragments/SearchPage/ListingCard";
import { isBigCard } from "@Utils/Functions";
import { PropertyCardSkeleton } from "shared-components/Components/Property/PropertyCard/PropertyCardSkeleton";

import dynamic from "next/dynamic";
import { NoResults } from "./NoResults";
import { useFacebookPixel } from "shared-components/GlobalHooks/web/FacebookPixel.hook";
import { FiltersStateContext } from "shared-components/Contexts/Filters/context";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import "shared-components/ViewFragments/SearchResults/Sider/ActiveFiltersTags/styles.less";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";
import { createSlotsForAds, positionAlternateAds } from "./ads";
import Ad from "src/hooks/ads/Ad";
import isEmpty from "lodash/isEmpty";
import { CitationsResults } from "shared-components/ViewFragments/SearchResults/Content/CitationsResults/web";

//@ts-ignore
const BannerSponsorSilver = dynamic(
	() =>
		import("shared-components/Components/Banners/SponsorSilver/web").then(
			mod => mod.BannerSponsorSilver
		),
	{ ssr: false }
);

export const Listings = ({
	data,
	loading = false,
	error,
	forceHideBanners = false,
	showExpenses = false,
}) => {
	const FP = useFacebookPixel();
	const screen = useWindowSize();
	const { country_code, isDefault } = useContext(ConfigStateContext);
	const { order } = useContext(FiltersStateContext);
	let fullData = [];

	if (data?.searchFast?.data) {
		fullData = data?.searchFast?.data;
	} else if (data?.landingSeo?.data) {
		fullData = data?.landingSeo?.data;
	}

	const [showSilverBanners, setShowSilverBanners] = useState<boolean>(false);
	const argentoSponsorBanner = [
		"https://cdn4.fincaraiz.com.co/web/655cb10a8aae9_original_hsbc_premier_campana-no-residentes_infocasas_v1-720x120px_1.gif",
		"https://cdn4.fincaraiz.com.co/web/655cb10a8b463_original_hsbc_premier_campana-no-residentes_infocasas_v1-720x120px_2.gif",
		"https://cdn4.fincaraiz.com.co/web/655cb10ab7742_original_hsbc_premier_campana-no-residentes_infocasas_v1-720x120px_3.gif",
	];
	const [isFromAr, setIsFromAr] = useState(false);

	const onClickBannerArgento = e => {
		if (data?.sponsorSilver) {
			FP.StandardEvent("sponsor_silver");
			if (e.ctrlKey || e.metaKey) return false;
		}
	};

	useEffect(() => {
		if (forceHideBanners == false) {
			setShowSilverBanners(true);
		} else {
			setShowSilverBanners(false);
		}
	}, [data]);

	useEffect(() => {
		//Temporary commented
		// ipIsFromCountry("AR")
		//     .then((res) => setIsFromAr(res))
	}, []);

	const printResults = res => {
		let holesPoints = 0;
		const sumMediaPosition = 2;

		return (
			<>
				{res?.map((prop: any, i: number) => {
					const bigCard = isBigCard(prop.highlight, order.value, country_code);
					holesPoints += bigCard ? 1 : 1; //ambos valen 1. no quiero que se muestren más de 1 banner por página
					const couldPrintBanner = holesPoints % 12 == 0; // mod 12 es la cantidad de puntos en 4 filas (3 huecos x 4 filas)
					const randomBanner = Math.floor(Math.random() * argentoSponsorBanner.length);

					return (
						<React.Fragment key={`lc-card-${prop.id}-${i}`}>
							{i === sumMediaPosition && country_code === "CO" &&(
								<div id="summedia" className="summedia">
									{/* this tag is requirement for ads, validate it for delete in the future */}
									<sum-media></sum-media>
								</div>
							)}
							<div style={{ width: "100%" }}>
								<ListingCard
									showExpenses
									showDuplicated={true}
									data={prop}
									preloadImg={i < 3}
								/>
							</div>

							{/* Insert citations after the 4th property (index 3) */}
							{i === 3 && <CitationsResults />}

							{couldPrintBanner && i === 2 && isFromAr ? (
								<a
									href={
										"https://www.hsbcdigital.com.uy/MainContact/?utm_source=1&utm_medium=4&utm_campaign=1&utm_term=4&utm_content=1"
									}
									target="_blank"
									onClick={onClickBannerArgento}
									rel="nofollow"
									className={"sponsor-silver-banner"}>
									<img src={argentoSponsorBanner[randomBanner]} alt={"HSBC"} />
								</a>
							) : couldPrintBanner &&
							  i != 0 &&
							  i < res?.length - 1 &&
							  showSilverBanners ? (
								<BannerSponsorSilver />
							) : null}
						</React.Fragment>
					);
				})}
			</>
		);
	};

	const printFincaResults = () => {
		let sumMediaPosition = 2;
		if (screen.xs) sumMediaPosition = 1;
		if (screen.xl) sumMediaPosition = 3;

		const Slots = {
			xs: [2, 10, 18, 20],
			sm: [4, 13, 20],
			xl: [6, 13, 20],
		};
		const listingData = createSlotsForAds(fullData, Slots, screen.xs, false, screen.xl);

		function generateSlotAds(adConfig) {
			if (adConfig) {
				const { adName, sizes, className, slotId, isFluid, gridClassName } = adConfig;
				const rootAdClass = isEmpty(className) ? "" : className;
				const rootGridClassName = isEmpty(gridClassName) ? "" : gridClassName;

				return (
					<div className={rootGridClassName} style={{ display: "flex", width: "100%" }}>
						<Ad
							slotId={slotId}
							adUnit={adName}
							sizes={sizes}
							classes={{ root: rootAdClass }}
							isFluid={isFluid}
							parentIntersection="listingResult"
						/>
					</div>
				);
			}

			return null;
		}

		const getAlternateAds = (index: number) => {
			if (screen.xs) {
				return generateSlotAds(positionAlternateAds.mobile[index]);
			}

			if (screen.xl) {
				return generateSlotAds(positionAlternateAds.desktop[index]);
			}

			return generateSlotAds(positionAlternateAds.tablet[index]);
		};

		return (
			<>
				{listingData?.map((listing, index) => {
					const card = listing ? (
						<ListingCard
							data={listing}
							preloadImg={index < 3}
							showExpenses
							isFromListing
						/>
					) : (
						getAlternateAds(index)
					);
					return (
						// eslint-disable-next-line react/no-array-index-key
						<Fragment key={index}>
							{index === sumMediaPosition && (
								<div id="summedia" className="summedia">
									{/* this tag is requirement for ads, validate it for delete in the future */}
									<sum-media></sum-media>
								</div>
							)}
							{card}
							{/* Insert citations after the 4th property in Colombia (Finca Raiz) */}
							{index === 3 && listing && <CitationsResults />}
						</Fragment>
					);
				})}
			</>
		);
	};

	return (
		<>
			{!fullData || fullData.length == 0 ? (
				<NoResults />
			) : (
				<section className="listingsWrapper">
					{loading ? (
						[...Array(10)].map((_, index) => (
							<PropertyCardSkeleton key={index} big={screen.xl && screen.lg} />
						))
					) : (
						<>{printResults(fullData)}</>
					)}
				</section>
			)}
		</>
	);
};

